import { render, staticRenderFns } from "./PemakaianKasKecil.vue?vue&type=template&id=05d75a8f&"
import script from "./PemakaianKasKecil.vue?vue&type=script&lang=js&"
export * from "./PemakaianKasKecil.vue?vue&type=script&lang=js&"
import style0 from "./PemakaianKasKecil.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports